<template>
  <div>
    <!-- 共用底部 dxm -->
    <div class="footer">
      <div class="footer_main container">
        <div class="footer_main_left">
          <div class="left_logo">
            <img :src="footerData.shop_buttom_logo" />
          </div>
          <div class="left-text">
            <p class="title">{{ footerData.company_name }}</p>
            <p>{{ langSet == "cn" ? "联系地址" : "Address" }}：</p>
            <p>
              {{
                langSet == "cn"
                  ? footerData.company_address
                  : "15th Floor, Tower B, Ping An International Finance Center, 1-3 South Xinyuan Road, Chaoyang District, Beijing"
              }}
            </p>
          </div>
        </div>
        <div class="footer_main_middle">
          <ul>
            <li>
              <img :src="footerData.wx_xcx" />
              <div>
                {{ langSet == "cn" ? "微信小程序" : "WeChat Mini Program" }}
              </div>
            </li>
            <li v-if="footerData.wx_gongzhonghao">
              <img :src="footerData.wx_gongzhonghao" />
              <div>{{ langSet == "cn" ? "公众号" : "Official Account" }}</div>
            </li>
            <li v-if="footerData.wx_video">
              <img :src="footerData.wx_video" />
              <div>
                {{ langSet == "cn" ? "微信视频号" : "Weixin Channels" }}
              </div>
            </li>
          </ul>
        </div>
        <div class="footer_main_right">
          <div class="title">
            {{ langSet == "cn" ? "联系我们" : "Contact Us" }}
          </div>
          <p
            v-if="
              footerData.market_cooperation !== '' ||
              footerData.market_cooperation_en !== ''
            "
          >
            {{ langSet == "cn" ? "市场合作" : "Marketing Manager" }}：{{
              langSet == "cn"
                ? footerData.market_cooperation
                : footerData.market_cooperation_en
            }}
          </p>
          <p
            v-if="
              footerData.conference_collaboration !== '' ||
              footerData.conference_collaboration_en !== ''
            "
          >
            {{ langSet == "cn" ? "会议合作" : "Conference Manager" }}：{{
              langSet == "cn"
                ? footerData.conference_collaboration
                : footerData.conference_collaboration_en
            }}
          </p>
          <p
            v-if="
              footerData.website_collaboration !== '' ||
              footerData.website_collaboration_en !== ''
            "
          >
            {{
              langSet == "cn"
                ? "市场/会议/网站合作"
                : "Marketing / Conference / Website Manager"
            }}：{{
              langSet == "cn"
                ? footerData.website_collaboration
                : footerData.website_collaboration_en
            }}
          </p>
          <p v-if="footerData.international_busines !== ''">
            International Business: {{ footerData.international_busines }}
          </p>
          <p v-if="footerData.internation_sales !== ''">
            Internation Sales: {{ footerData.internation_sales }}
          </p>
          <p v-if="footerData.internation_marketing !== ''">
            Internation Marketing: {{ footerData.internation_marketing }}
          </p>
          <p class="flex" v-if="langSet == 'en'">
            <a href="https://www.facebook.com/profile.php?id=61581058019048"
              ><img class="p_icon" src="../assets/icon_f1.jpg"
            /></a>
            <a href="https://www.linkedin.com/company/apichina/">
              <img class="p_icon" src="../assets/icon_in.jpg"
            /></a>
          </p>
        </div>
      </div>
      <div class="footer-line"></div>
      <div class="footer-copyright" v-if="copyRight.length > 0">
        <div v-for="(v, i) in copyRight" :key="i">
          <span
            class="footer-copyright-label"
            @click="handleClickCopyright(v)"
            >{{ v.key }}</span
          >
          <span v-if="i != copyRight.length - 1">|</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { webMenu, getWebsiteBase, getCopyright } from "@/api/api";

export default {
  data() {
    return {
      langSet: "",
      nav: [],
      screenWidth: 0,
      footerData: {},
      copyRight: [],
      showTooltip: false,
      metaData: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.getMenu();
    //25.9.23 获取网站基本信息 dxm
    this.getWebsite();
    //25.9.23 获取备案信息 dxm
    this.getCopyrightData();
  },
  methods: {
    // 获取屏幕宽度和高度的函数
    getScreenSize() {
      return {
        width: window.innerWidth,
      };
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.is_bottom == "是") {
                arr.push(item);
              }
            });
            this.nav = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWebsite() {
      getWebsiteBase()
        .then((res) => {
          if (res.code == 1) {
            this.footerData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCopyrightData() {
      getCopyright()
        .then((res) => {
          if (res.code == 1) {
            this.copyRight = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转页面
    toLink(item) {
      if (item.http_url_cn || item.http_url_en) {
        if (item.type == "内部跳转") {
          this.$router.push({
            path: this.langSet == "cn" ? item.http_url_cn : item.http_url_en,
          });
        } else {
          let path = this.langSet == "cn" ? item.http_url_cn : item.http_url_en;
          window.open(path, "_blank");
        }
      } else {
        window.open(item, "_blank");
      }
    },
    handleClickCopyright(flag) {
      if (flag.value) {
        window.open(flag.value, "_blank");
      }
    },
  },
};
</script>

<style lang="scss">
.footer {
  width: 100%;
  height: auto;
  color: #fff;
  padding-top: 74px;
  background: #001a33;
  border-radius: 60px 60px 0px 0px;
  box-sizing: border-box;
  .footer_main {
    display: flex;
    justify-content: space-between;
    padding-bottom: 46px;
    .footer_main_left {
      width: 316px;
      height: auto;
      margin-right: 79px;
      overflow: hidden;
      .left_logo {
        width: 235px;
        height: 79px;
        overflow: hidden;
        img {
          height: 100%;
        }
      }
      .left-text {
        width: 100%;
        height: auto;
        line-height: 20px;
        margin-top: 20px;
        font-size: 12px;
        overflow: hidden;
        .title {
          font-size: 22px;
          line-height: 28px;
          padding-bottom: 10px;
        }
      }
    }
    .footer_main_middle {
      flex: 1;
      height: auto;
      overflow: hidden;
      margin-top: 6px;
      ul {
        display: flex;
        li {
          width: 118px;
          font-size: 14px;
          line-height: 20px;
          text-align: center;
          margin-right: 68px;
          img {
            width: 100%;
            height: 118px;
            display: block;
            margin-bottom: 12px;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .footer_us {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        line-height: 64px;
      }
      .footer_icon {
        width: 70%;
        padding: 60px 0;
        border-radius: 7px;
        margin: 0 auto;
        background: rgba(255, 255, 255, 0.32);
        a {
          padding: 0 10px;
          position: relative;
          .tooltip {
            position: absolute;
            bottom: 0;
            right: -110px;
            z-index: 9;
            img {
              width: 150px;
              height: 150px;
            }
          }
        }
        img {
          width: 60px;
          height: 60px;
        }
      }
    }
    .footer_main_right {
      width: 339px;
      height: auto;
      overflow: hidden;
      font-size: 12px;
      line-height: 28px;
      .title {
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        padding-bottom: 12px;
      }
      .p_icon {
        width: 30px;
        margin: 10px 10px 0 0;
      }
    }
  }
  .fmright {
    margin-right: 29px;
  }
  .footer-line {
    width: 1200px;
    height: 1px;
    margin: 0 auto 0;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      #ffffff 50%,
      rgba(255, 255, 255, 0) 100%
    );
  }
  .footer-copyright {
    height: 44px;
    line-height: 44px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    span {
      margin-right: 8px;
    }
    .footer-copyright-label {
      cursor: pointer;
    }
  }
}
@media only screen and (max-width: 1280px) {
  // .footer .footer_main .footer_main_right {
  //   display: none;
  // }
  .footer .footer_main .footer_main_middle {
    margin-right: 0;
    ul {
      li {
        font-size: 12px;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .footer .footer-line {
    width: 80%;
  }
}
@media only screen and (max-width: 767px) {
  .footer {
    height: auto;
    padding-top: 0.96rem;
    .container {
      padding-bottom: 0.48rem;
    }
    .footer_main {
      flex-wrap: wrap;
      .footer_main_left {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 100%;
        margin-right: 0;
        .left_logo {
          width: 3.13rem;
          height: 1.06rem;
          margin-right: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .left-text {
          width: 100%;
          margin-top: 10px;
        }
      }
      .footer_main_middle {
        width: 100%;
        flex: inherit;
        margin: 0.48rem 0;
        ul {
          justify-content: center;
        }
        ul li {
          width: 1.5rem;
          font-size: 0.27rem;
          img {
            width: 100%;
            height: 1.5rem;
            margin-right: 0.25rem;
          }
        }
        .footer_us,
        .footer_icon {
          display: none;
        }
      }
    }
  }
  .footer .footer-copyright {
    height: auto;
    padding: 0.29rem 0.5rem;
    font-size: 0.14rem;
    color: #ffffff;
    line-height: 0.33rem;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    span {
      margin-right: 0.15rem;
    }
  }
}
</style>